import React from "react";
import clsx from "clsx";

import "./index.scss";

import LoginContent from "../../components/Login/Content";
import Footer from "../../components/Footer";
import Header from "../../components/Header/Header";
import { IS_MOBILE } from "@/utils/tool";

const Login: React.FC = () => {
  return (
    <div className={clsx("login-box", IS_MOBILE && "isMobile")}>
      <Header showLogo={false} isHideUser={true}></Header>
      <LoginContent type="login" />
      <Footer />
    </div>
  );
};

export default Login;
